import { useEffect, useState } from "react";
import type { TimelineEntry } from "@ferrivia/api-contract";
import { useApi } from "@ferrivia/auth-web";

export type PatientTimelineState =
  | { status: "loading" }
  | { status: "error"; error: string }
  | { status: "success"; entries: TimelineEntry[] };

export function usePatientTimeline(id: string | undefined): PatientTimelineState {
  const api = useApi();
  const [state, setState] = useState<PatientTimelineState>({ status: "loading" });

  useEffect(() => {
    if (!id) {
      return;
    }
    let cancelled = false;
    setState({ status: "loading" });
    api.patients
      .timeline(id)
      .then((entries) => {
        if (!cancelled) {
          setState({ status: "success", entries });
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setState({ status: "error", error: err instanceof Error ? err.message : "Failed to load timeline" });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [api, id]);

  return state;
}
